/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const MemberListResponse = zod
	.array(
		zod
			.object({
				email: zod.email().describe('User email'),
				id: zod.string().describe('User ID'),
				joined_at: zod.iso.datetime({ offset: true }).describe('When the user joined'),
				role: zod.enum(['owner', 'member'])
			})
			.describe('Organization member')
	)
	.describe('List of organization members');

export type MemberListResponse = zod.input<typeof MemberListResponse>;
export type MemberListResponseOutput = zod.output<typeof MemberListResponse>;
